import React from 'react';
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { alpha } from "@mui/material/styles";
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import moment from "moment";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
const YearPicker = (props) => {
    const { name, control, label, value, placeholder } = props;

    let textFiledStyles = {
        '& .MuiFilledInput-root': {
            backgroundColor: 'background.paper',
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'neutral.300',
            borderRadius: 1,
            boxShadow: '0px 1px 2px 0px rgba(9, 30, 66, 0.08)',
            overflow: 'hidden',
            p: 0,
            transition: (theme) => theme.transitions.create([
                'border-color',
                'box-shadow'
            ]),
            '&:before': {
                borderBottom: 0
            },
            '&:hover': {
                backgroundColor: 'background.paper'
            },
            '&.Mui-focused': {
                backgroundColor: 'background.paper',
                boxShadow: (theme) => `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`
            },
            '&.Mui-disabled': {
                backgroundColor: 'action.disabledBackground',
                boxShadow: 'none',
                borderColor: alpha('#D6DBE1', 0.5)
            },
            '.MuiInputAdornment-root.MuiInputAdornment-positionStart.MuiInputAdornment-root:not(.MuiInputAdornment-hiddenLabel)': {
                mt: 0,
                ml: 1.5
            }
        },
    };

    let InputLabelProps = {
        shrink: true,
        sx: {
            color: 'text.primary',
            fontSize: 14,
            fontWeight: 500,
            mb: 0.5,
            position: 'relative',
            transform: 'none'
        }
    };

    let inputProps = {
        sx: {
            alignItems: 'center',
            display: 'flex',
            fontSize: 14,
            height: 'unset',
            lineHeight: 1.6,
            px: 1.5,
            py: 0.75,
            '&.MuiInputBase-inputAdornedStart': {
                pl: 0
            }
        }
    };


    const getFormattedValue = (value) => {
        if (moment.isMoment(value)) {
            return value.format('YYYY');
        } else {
            return value;
        }


    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Controller
                name={name}
                control={control}
                defaultValue={props.value ? new Date(props.value) : null}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <DesktopDatePicker
                        label={label}
                        value={value}
                        onChange={onChange}
                        views={["year"]}
                        disableFuture
                        readOnly={props.readOnly}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                sx={textFiledStyles}
                                InputLabelProps={InputLabelProps}
                                variant="filled"
                                value={getFormattedValue(value)}
                                helperText={error ? error.message : null}
                                error={!!error}
                                inputProps={inputProps}
                                placeholder={placeholder}

                            />
                        )}
                    />
                )}
            />
        </LocalizationProvider>
    );
};

export default YearPicker;


